import script from "./ServerView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServerView.vue?vue&type=script&setup=true&lang=ts"

import "./ServerView.vue?vue&type=style&index=0&id=4eddd4d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eddd4d0"]])

export default __exports__